module.exports = __webpack_public_path__ + "img/barcelona_sant_marti.94b7e312.jpg";